module.exports = __webpack_public_path__ + "img/Logowall-before-old.91a5d735.png";